var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuiguanfamen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.2 2.6V5H8.8V2.6H11.2C11.6418 2.6 12 2.24183 12 1.8C12 1.35817 11.6418 1 11.2 1H4.8C4.35817 1 4 1.35817 4 1.8C4 2.24183 4.35817 2.6 4.8 2.6H7.2Z",
    fill: "#26A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.875 14.5833H1.5V10.0833H1.875H5.375H5.875V9.58333V5.91667V5.5H10.125V5.91667V9.58333V10.0833H10.625H14.125H14.5V14.5833H14.125H1.875Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuiguanfamen);
export default __webpack_public_path__ + "static/media/shuiguanfamen.a6fdd5aaeee78694e239049ae2c648ed.svg";
export { ForwardRef as ReactComponent };